import { Directive, ElementRef, OnInit } from '@angular/core';
import { ActivatedRoute, RouterOutlet } from '@angular/router';
import { NamedRouterOutletService } from './named-router-outlet.service';

@Directive({ selector: 'router-outlet[y42NamedRouterOutlet]', standalone: true })
export class NamedRouterOutletDirective implements OnInit {
  constructor(
    private readonly route: ActivatedRoute,
    private readonly outlet: RouterOutlet,
    private readonly routerOutletService: NamedRouterOutletService,
    private readonly elementRef: ElementRef,
  ) {}

  ngOnInit() {
    const { outlet, route } = this;
    const html = this.elementRef.nativeElement as HTMLElement;
    const name = html.attributes.getNamedItem('name')?.value;

    if (!name) {
      throw new Error(`[NamedRouterOutlet]: no name applied to router-outlet`);
    }

    this.routerOutletService.register(name, outlet, route);
  }
}
